import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Rate({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Rate</title>
      <path
        d="M21 7.5V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V7.5M21 16.5V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V16.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75V11.25ZM7 12V12.75C7.23607 12.75 7.45836 12.6389 7.6 12.45L7 12ZM10 8L10.7022 7.73666C10.606 7.48012 10.3776 7.29646 10.1064 7.25759C9.83521 7.21871 9.56439 7.33082 9.4 7.55L10 8ZM13 16L12.2978 16.2633C12.394 16.5199 12.6224 16.7035 12.8936 16.7424C13.1648 16.7813 13.4356 16.6692 13.6 16.45L13 16ZM16 12V11.25C15.7639 11.25 15.5416 11.3611 15.4 11.55L16 12ZM21 12.75C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25V12.75ZM3 12.75H7V11.25H3V12.75ZM7.6 12.45L10.6 8.45L9.4 7.55L6.4 11.55L7.6 12.45ZM9.29775 8.26334L12.2978 16.2633L13.7022 15.7367L10.7022 7.73666L9.29775 8.26334ZM13.6 16.45L16.6 12.45L15.4 11.55L12.4 15.55L13.6 16.45ZM16 12.75H21V11.25H16V12.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
